module.exports = __webpack_public_path__ + "static/media/topbarIcon1.ca983922.svg";